import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { useAuthStore, isValidToken } from '../../stores/authStore';

/**
 * 公开路由组件
 * 用于已登录用户访问登录页等公开页面时自动跳转
 * 如果已登录且 token 有效，自动跳转到 dashboard
 */
export default function PublicRoute() {
  const location = useLocation();
  const { token, isAuthenticated } = useAuthStore();

  // 检查用户是否已认证且 token 有效
  const isAuthValid = isAuthenticated && isValidToken(token);

  if (isAuthValid) {
    // 已登录，从 location.state 中获取之前尝试访问的地址，或默认跳转到 dashboard
    const from = (location.state as { from?: string })?.from || '/dashboard';
    return <Navigate to={from} replace />;
  }

  // 未认证，渲染子路由（登录页）
  return <Outlet />;
}
